import React from "react";
import "./App.css";
import NavBar from "./components/navBar/NavBar";
import CustomCarousel from "./components/carousel/Carousel";
import TitleMessage from "./components/TitleMessage/titleMessage";
import About from "./views/about/About";
import { Parallax } from "react-parallax";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import Skills from "./views/skills/skills";
import Projects from "./views/projects/projects";
import Faq from "./views/faq/faq";
import PatientInformation from "./views/patientInformation/patientInformation";
import Contact from "./views/contact/Contact";
import Footer from "./components/footer/Footer";
import ParallaxImage from "./components/ParallaxImage";
import ParallaxBackground from "./assets/img/background/background.jpg";

function App() {
  return (
    <div className="App" style={{ position: "relative", margin: 0, padding: 0 }}>
      <NavBar />
      <div id="home"/>
      <ParallaxImage image={require("./assets/img/background/globulos_rojos_2x.png")} />
      <TitleMessage />
      <div>
        <Parallax
          blur={{ min: -30, max: 30 }}
          bgImage={ParallaxBackground}
          bgImageAlt=""
          strength={-200}
        >
          <div>
            <Fade left duration={2000}>
              <About />
            </Fade>
          </div>
        </Parallax>
      </div>
  <ParallaxImage image={require("./assets/img/background/globulos_rojos_2x.png")} />
      {/* <div>
        <Parallax
          blur={{ min: -30, max: 30 }}
          bgImage={require("./assets/img/parallex/background.webp")}
          bgImageAlt=""
          strength={-200}
        >
          <div>
            <Fade right duration={2000}>
              <Skills />
            </Fade>
          </div>
        </Parallax>
      </div> */}
      {/* <ParallaxImage image={require("./assets/img/background/globulos_rojos_2x.png")} /> */}
      <div>
        <Parallax
          blur={{ min: -30, max: 30 }}
          bgImage={ParallaxBackground}
          bgImageAlt=""
          strength={-200}
        >
          <div>
            <Slide bottom duration={1000}>
              <hr />
              <Projects />
            </Slide>
          </div>
        </Parallax>
      </div>
      {/* Separator between FAQ and Patient Information */}
      <ParallaxImage image={require("./assets/img/background/globulos_rojos_2x.png")} />
      <div>
        <Parallax
          blur={{ min: -30, max: 30 }}
          bgImage={ParallaxBackground}
          bgImageAlt=""
          strength={-200}
        >
          <div>
            <Slide bottom duration={1000}>
              <hr />
              <PatientInformation />
            </Slide>
          </div>
        </Parallax>
      </div>
      <ParallaxImage image={require("./assets/img/background/globulos_rojos_2x.png")} />
      <div>
        <Parallax
          blur={{ min: -30, max: 30 }}
          bgImage={ParallaxBackground}
          bgImageAlt=""
          strength={-200}
        >
          <div>
            <Slide bottom duration={1000}>
              <hr />
              <Faq />
            </Slide>
          </div>
        </Parallax>
      </div>
      <div>
        <Parallax
          blur={{ min: -30, max: 30 }}
          bgImage={ParallaxBackground}
          bgImageAlt=""
          strength={-200}
        >
          <div>
            <Fade bottom duration={2000}>
              <hr />
              <Contact />
            </Fade>
          </div>
        </Parallax>
      </div>
      <hr />
      <Footer />
    </div>
  );
}

export default App;
